export interface AppAdministratorTrainingsRootListFormRemove {
  id: string;
  user_id: string;
  organization_id: string;
  training_category_id: string;
  training_category: {
    id: string;
    content: {
      name: string;
      fields: any;
    }
  }
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  }
  content: {
    date: string;
    fields: any;
  };
}

export class AppAdministratorTrainingsRootListFormRemove implements AppAdministratorTrainingsRootListFormRemove {
  id: string;
  user_id: string;
  organization_id: string;
  training_category_id: string;
  content: {
    date: string;
    fields: any;
  };
  training_category: {
    id: string;
    content: {
      name: string;
      fields: any;
    }
  }
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  }

  constructor() {
    this.id = "";
    this.user_id = "";
    this.organization_id = "";
    this.training_category_id = "";
    this.content = {
      date: "",
      fields: [],
    };
    this.training_category = {
      id: "",
      content: {
        name: "",
        fields: [],
      }
    };
    this.user = {
      id: "",
      content: {
        name: "",
        surname: "",
      },
    };
  }
}